import http from "../httpService";
import {getBaseUrl} from "../../config";


export const submitAdminServiceSendSendSms = data => {
  return http.post(
    `${getBaseUrl()}/admin_service_send_notification`,
    data
  );
};
